import Vue from 'vue'
import Wedding from './Wedding.vue'
new Vue({
  el: '#app',
  render: h => h(Wedding)
})
